import type { Logger } from '@wg/api-client';

const logger: Logger = {
  debug: (message, meta) => {
    if (import.meta.env.DEV) console.debug(message, meta ?? '');
  },
  info: (message, meta) => console.info(message, meta ?? ''),
  warn: (message, meta) => console.warn(message, meta ?? ''),
  error: (message, meta) => console.error(message, meta ?? ''),
};

export default logger;
